import { z } from "zod/v4";

const immobilisationLinesSchema = z.object({
  _id: z.string(),
  amortissementPrécédentCent: z.number().int().nonnegative(),
  amortissementCent: z.number().int().positive(),
  amortissementCumuléCent: z.number().int().nonnegative(),
  valeurRésiduelleCent: z.number().int().nonnegative(),
  yearStartDate: z.date(),
});

const immobilisationSchema = z.object({
  _id: z.string().nullable(),
  owner: z.string().nullable(),
  name: z.string(),
  principalCent: z.number().int().positive(),
  years: z.number().int().positive(),
  startDate: z.date(),
  mode: z.enum(["linéaire", "dégressif"]),
  amortissementLines: z.array(immobilisationLinesSchema),
});

export const validateImmobilisation = (immobilisation: unknown) => {
  return immobilisationSchema.parse(immobilisation);
};
